import TSUtils from "../../../utils/helpers/TSUtils";

export const recomputeValueEstimationForAction = (
  nActions: number | undefined,
  multiplier: number | undefined,
  currency: string,
  subUnits: number,
  ctaValue: number
) => {
  if (!nActions || !multiplier) {
    return TSUtils.formatAmountUsingIntl(0, subUnits, currency);
  }
  return TSUtils.formatAmountUsingIntl(
    nActions * multiplier * ctaValue,
    subUnits,
    currency
  );
};
